import { useAlert, type AlertDescriptor } from '@/hooks/useAlert.hook';
import { AlertMode } from '@/components/Alert/types';
import { extractErrorMessage } from '@/util/http-utils';

export type ActionFunction = (closeFunc: VoidFunction) => void;
export type ListenerFunction = (display: boolean, id?: string) => void;

// export interface NotificationButton {
//     icon?: FunctionComponent;
//     title: string;
//     action: ActionFunction;
// }

export class UserNotificationManager {

    private static report(desc: AlertDescriptor) {
        const showAlert = useAlert.getState().show;
        showAlert(desc);
    }

    public static reportError(title: string, error: string | Error)  {
        UserNotificationManager.report({ mode: AlertMode.ERROR, generalMessage: title, detailMessage: extractErrorMessage(error) });
    }

    public static reportWarning(title: string, detail: string, ) {
        UserNotificationManager.report({ mode: AlertMode.WARNING, generalMessage: title, detailMessage: detail });
    }

    public static reportInfo(title: string, detail: string) {
        UserNotificationManager.report({ mode: AlertMode.INFO, generalMessage: title, detailMessage: detail });
    }
}
